import Typograf from 'typograf';

// Создаем экземпляр Typograf с настройками для русского языка
const tp = new Typograf({ locale: ['ru', 'en-US'] });

/**
 * Универсальная функция для форматирования текста с помощью Typograf
 * для исправления висящих предлогов и других типографических проблем
 * Всегда сохраняет переносы строк для корректного отображения
 * @param {string} text - Исходный текст для форматирования
 * @returns {string} - Отформатированный текст
 */
export const formatText = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  
  try {
    // Сохраняем переносы строк, форматируя каждую строку отдельно
    const lines = text.split('\n');
    const formattedLines = lines.map(line => tp.execute(line));
    return formattedLines.join('\n');
  } catch (error) {
    console.warn('Typograf error:', error);
    return text;
  }
};